/*
* main.js
*
* Description: main.js
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Crewplanning"
* Copyright 2018,2019,2020,2021,2022,2023 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import App from './App.vue';
import '@babel/polyfill'; // ???


import router from './routers/router';
import { store } from './stores/store';
import './filters/filters';
import './plugins/base';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import SundAir2021Plugin from './plugins/sundair2021-plugin.js';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Toasted from 'vue-toasted';


// >>> ------------------------------------------------------------------------- 'Global Vue - Config'
Vue.config.productionTip = false;


// >>> ------------------------------------------------------------------------- 'Global Axios - Config'
axios.defaults.baseURL = '/rest';
axios.defaults.timeout = 60000;
axios.defaults.headers = {
    Accept: 'application/json',
    langCode: 'DE',
    apiKey: '037ae1f2ba244a2a93b24121743bfdd6', // sdr key
    Authorization: null
};
axios.interceptors.request.use(config => {
    var lang = 'DE';
    //     localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')); // catch

    // // Language in localStrage?
    // if (localStorageLanguage !== null) {
    //     lang = localStorageLanguage.value.toUpperCase();
    // }

    config.headers.langCode = lang;

    // before a request is made start the nprogress
    // NProgress.start();
    return config;
});
axios.interceptors.response.use(response => {
    // before a response is returned stop nprogress
    // NProgress.done();
    return response;
});


// >>> ------------------------------------------------------------------------- 'Global Plugin'
Vue.use(SundAir2021Plugin);


// >>> Init Plugin - Loading ---------------------------------------------------
Vue.use(Loading);


// >>> Global Toast ------------------------------------------------------------
Vue.use(Toasted);
let toastOptionsError = {
    type: 'error',
    icon: 'soap-icon-insurance',
    iconPack: 'custom-class',
    position: 'top-center',
    fullWidth: true,
    fitToScreen: true,
    closeOnSwipe: true,
    duration: 5000,
    className: 'toast_custom-font-error'

};
Vue.toasted.register('sdr_app_error', (payload) => {

    // if there is no message passed show default message
    if (!payload.message) {
        return 'Oops.. Something Went Wrong..';
    }

    // if there is a message show it with the message
    return 'Oops.. ' + payload.message;

}, toastOptionsError);


let toastOptionsInfo = {
    type: 'info',
    icon: 'soap-icon-insurance',
    iconPack: 'custom-class',
    position: 'top-center',
    fullWidth: true,
    fitToScreen: true,
    closeOnSwipe: true,
    duration: 5000,
    className: 'toast_custom-font-info'
};
Vue.toasted.register('sdr_app_info', (payload) => {

    // if there is no message passed show default message
    if (!payload.message) {
        return 'Oops.. Something Went Wrong..';
    }

    // if there is a message show it with the message
    return 'Worked.. ' + payload.message;

}, toastOptionsInfo);


let toastOptionsInfo2 = {
    type: 'info',
    icon: 'soap-icon-insurance',
    iconPack: 'custom-class',
    position: 'bottom-center',
    fullWidth: false,
    fitToScreen: true,
    closeOnSwipe: true,
    duration: 10000,
    className: 'toast_custom-font-info'
};
Vue.toasted.register('sdr_app_info2', (payload) => {

    // if there is no message passed show default message
    if (!payload.message) {
        return 'Oops.. Something Went Wrong..';
    }

    // if there is a message show it with the message
    return payload.message;

}, toastOptionsInfo2);


// >>> ------------------------------------------------------------------------- 'Global Eventbus'
export const eventBus = new Vue();


// ----------------------------------------------------------------------------- Go Go Go..
// -----------------------------------------------------------------------------
new Vue({
    router,
    store,
    vuetify,
    i18n,

    /***************************************************************************
    * Instant LifeCycle(s)
    *
    * Desc: Set Authorization/Language Headers.
    * Note: See Sdr-Plugin.
    * Note: OFF for the Moment. Reason: We got  a Login first.
    *
    */
    created: function () {

        // axios.defaults.headers.Authorization = this.$make_basic_auth();
        // axios.defaults.headers.langCode = this.$header_language();

    }, // eof created()

    render: h => h(App)

}).$mount('#app');
